import { render, staticRenderFns } from "./ContractsTotalizer.vue?vue&type=template&id=079ec71a"
import script from "./ContractsTotalizer.vue?vue&type=script&lang=js"
export * from "./ContractsTotalizer.vue?vue&type=script&lang=js"
import style0 from "./ContractsTotalizer.vue?vue&type=style&index=0&id=079ec71a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports